import { j as r } from "./atoms-v218.js";
import { forwardRef as G, useContext as h, useMemo as C } from "react";
import { GridHelper as k } from "./atoms-v2137.js";
import { Grid as B } from "./atoms-v2138.js";
import { GridContext as $ } from "./atoms-v2123.js";
import { GridHelperProvider as H } from "./atoms-v2124.js";
import { useBreakpoints as P } from "./atoms-v251.js";
const w = G(
  ({
    children: s,
    className: e = "",
    colGap: o = void 0,
    debug: t = !1,
    hAlign: m = "start",
    id: n,
    isRoot: i = !1,
    rowGap: a,
    tagName: d = "div",
    vAlign: p = "start",
    wrap: f,
    ...l
  }, x) => {
    const { columns: c } = h($), { matches: j } = P(), u = C(
      () => /* @__PURE__ */ r.jsx(
        $.Provider,
        {
          value: {
            activeBreakpoints: j,
            colGap: o,
            columns: c
          },
          children: /* @__PURE__ */ r.jsxs(
            B,
            {
              $colGap: o,
              $hAlign: m,
              $isRoot: i,
              $rowGap: a,
              $vAlign: p,
              $wrap: f,
              as: d,
              className: [e, "atoms-grid"].filter((v) => v).join(" "),
              id: n,
              ref: x,
              ...l,
              children: [
                s,
                t ? /* @__PURE__ */ r.jsx(k, {}) : null
              ]
            }
          )
        }
      ),
      [
        s,
        e,
        o,
        c,
        t,
        m,
        n,
        i,
        j,
        x,
        l,
        a,
        d,
        p,
        f
      ]
    );
    return i ? /* @__PURE__ */ r.jsx(H, { debug: t, children: u }) : u;
  }
);
w.displayName = "Grid";
export {
  w as Grid
};
